import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '@env';
import {Select, Store} from '@ngxs/store';
import {AuthState} from '@shared/state/auth/auth.state';
import {Observable, of, zip} from 'rxjs';
import {map} from 'rxjs/operators';
import moment from 'moment';
import {Alert} from '@shared/interfaces';
import {collection, Firestore, query, where, orderBy, doc, setDoc, collectionSnapshots} from '@angular/fire/firestore';
import {DocumentData, QueryDocumentSnapshot} from 'rxfire/firestore/interfaces';

@Injectable({
  providedIn: 'root'
})
export class AlertService {
  headers: HttpHeaders;
  apiUrl: string;

  @Select(AuthState.getUserID) userId$: Observable<any>;

  constructor(private http: HttpClient, private store: Store, private firestore: Firestore) {
    this.apiUrl = environment.apiUrl;
  }

  getUrl(url): string {
    return `${this.apiUrl}/${url}`;
  }

  getAlertData(): Observable<Partial<any[]>> {
    const userId = this.store.selectSnapshot(AuthState.getUserID);
    const alertPath = `users/${userId}/alerts`;

    if (!userId) {
      return of([]);
    }
    return zip(this.getSlicedAlerts(alertPath))
      .pipe(
        map(documents => {
          let docs: QueryDocumentSnapshot<DocumentData>[] = [];
          documents.forEach(_doc => {
            docs = docs.concat(_doc);
          });
          return docs;
        }),
        map(documents => {
          const alertArray: Partial<Alert>[] = [];
          documents.forEach(_doc => {
            alertArray.push({
              id: _doc.id,
              ..._doc.data()
            });
          });
          return alertArray.reverse();
        })
      );
  }

  getSlicedAlerts(alertPath: string) {
    const dataCollection = collection(this.firestore, alertPath);
    const isWhereClause = where('isRead', '==', false);
    const dataQuery = query(dataCollection, isWhereClause, orderBy('updatedAt'));

    return collectionSnapshots(dataQuery);
  }

  createAlert(payload: Partial<Alert>) {
    const userId = this.store.selectSnapshot(AuthState.getUserID);
    const alertPath = `users/${userId}/alerts`;
    const timestamp = moment().format('YYYYMMDDHHmmss');

    const alertDoc = doc(this.firestore, alertPath, timestamp);
    return setDoc(alertDoc, {
      ...payload,
      createdAt: parseInt(timestamp, 10),
      isRead: false
    });
  }

  resolveAlert(alertId: string) {
    return this.http.post(this.getUrl('alerts/resolve'), {
      alertId
    })
      .toPromise();
  }
}
